export default function initializeTextMap() {
    document.querySelectorAll('.block-text-map').forEach( function( block ) {
        const googleMap = new TextMap(block);
    } );
}

class TextMap {
    constructor(block,) {
        this.block = block;
        this.apiKey = block.querySelector('.block-text-map__map').getAttribute('data-key');
        this.lat = Number(block.querySelector('.block-text-map__map').getAttribute('data-lat'));
        this.lng = Number(block.querySelector('.block-text-map__map').getAttribute('data-lng'));
        this.loadScript();
    }
    init() {
        const myIcon = {
            url: location.origin+'/app/themes/venti/assets/dist/images/marker.png',
            scaledSize: new google.maps.Size(45, 57), // Wymiary ikony
        };

        const myLatLng = { lat: this.lat, lng: this.lng };
        const mapOptions = {
            zoom: 15,
            center: myLatLng,
            styles: [{
                stylers: [{
                    saturation: -100
                }]
            }]
        };


        const map = new google.maps.Map(
            this.block.querySelector('#map'),
            mapOptions
        );
        const marker = new google.maps.Marker({
            position: myLatLng,
            map: map,
            icon: myIcon,
        });
    }
    loadScript() {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}`;
        script.onload = () => {
            this.init();
        };
        document.body.appendChild(script);
    }
}